import { Component, Input, OnInit } from '@angular/core';
import { Value } from '../../../classes/value';
import { IAlbum } from 'angular2-lightbox/src';
import { Lightbox } from 'ngx-lightbox';

export interface Image {
    collection_name: string; // Name of the collection that the image belongs to
    file_name: string; // Full file name
    full_urls: {
        default: string;
        thumbnail: string;
    };
    name: string; // Name of the file (without . and extension)
    order_column: number; // The order number in which the images should be represented
    size: number; // File size
}

export interface ImagesOptions {
    multiple?: boolean; // Whether it is possible to have multiple images or not
    value: Array<Image>;
    thumbnail?: string; // Name of the conversion that represents the thumbnail
    thumbnailUrl: string;
}

@Component({
    selector: 'chassis-datatable-value-images',
    templateUrl: './images.component.html',
    styleUrls: ['./images.component.scss'],
})
export class ImagesComponent extends Value<ImagesOptions> implements OnInit {
    @Input() data: ImagesOptions;

    protected lightBoxAlbum: Array<IAlbum> = [];

    /**
     * Init
     */
    public ngOnInit(): void {
        if (this.data && this.data.value.length) {
            this.initLightbox();
        }
    }

    /**
     * Constructor
     *
     * @param lightbox
     */
    public constructor(
        protected lightbox: Lightbox
    ) {
        super();
    }

    /**
     * Initialize lightbox album
     */
    protected initLightbox(): void {
        this.lightBoxAlbum = this.data.value.map(media => {
            return {
                caption: media.name,
                src: media.full_urls.default,
                thumb: media.full_urls.thumbnail
            }
        });

        const mapped = this.data.value.map(media => {
            return {
                caption: media.name,
                src: media.full_urls.default,
                thumb: media.full_urls.thumbnail
            }
        });
    }

    /**
     *
     */
    public openGallery(): void {
        this.lightbox.open(this.lightBoxAlbum, 0, {
            showImageNumberLabel: true,
            wrapAround: true,
            disableScrolling: true
        });
    }
}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/values/images/images.component.ts